//
// Smooth Scroll to Anchor
//

$('a.scrollto[href^="#"]').on('click', function(e) {
    'use strict';
    // prevent default anchor click behavior
    e.preventDefault();

    // store hash
    var hash = this.hash;

    // animate
    $('html, body').animate({
        scrollTop: $(hash).offset().top
    }, 300, function() {
        // when done, add hash to url
        // (default click behaviour)
        window.location.hash = hash;
    });
});